export const formatBitsPerSecond = (bits: number, decimals: number = 2): string => {
    if (bits === 0) return '0 Bps';

    const k = 1000;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bps', 'Kbps', 'Mbps', 'Gbps', 'Tbps'];

    const i = Math.floor(Math.log(bits) / Math.log(k));

    const unit = i < sizes.length ? sizes[i] : sizes[sizes.length - 1];

    return `${parseFloat((bits / Math.pow(k, i)).toFixed(dm))} ${unit}`;
}; 